<a class="menu-link"
   [routerLink]="menuItem.route"
   routerLinkActive="active"
   #rla="routerLinkActive"
   [attr.aria-current]="rla.isActive ? 'page' : null"
   [title]="tooltip">
  @if (menuItem.icon) {
    <i class="bi menu-icon" aria-hidden="true" [ngClass]="menuItem.icon"></i>
  }
  @if (!collapsed) {
    <span class="menu-text">
      <span class="menu-title">{{ menuItem.title }}</span>
      @if (hint) {
        <span class="menu-hint">{{ hint }}</span>
      }
    </span>
  }
</a>
